import React from "react";
import { Head, Card } from "../../../components/template";

const Retreats = () => {
  const retreats = [
    {
      title: "SYNERGISE",
      bestFor: "Boosting physical and mental health, Stress relief, Relaxation, & Overall well-being",
      gain: "Recharge your body & mind, feel lighter, and learn holistic wellness habits.",
      image: "/assets/home/SYNNERGISE.jpg", 
      link: "/retreats/synnergise", 
    },
    {
      title: "INNERGISE",
      bestFor: "Boosting Mental & Emotional Strength, Deep self-reflection, Inner peace",
      gain: "Understand your inner working, Break limiting patterns, find clarity, & strengthen inner peace.",
      image: "/assets/home/Transformative Retreats.jpeg", 
      link: "/retreats/innergise",    },
    {
      title: "InnerQuiet",
      bestFor: "Complete Mental detox, Deeper self-awareness & Discovering purpose",
      gain: "Silence mental chatter, gain clarity, & reconnect with your inner intelligence.",
      image: "assets/home/INVISION.jpg",
    link: "/retreats/innerQuiet", 
    },
  ];

  return (
    <div className="bg-light px-6 py-12">
      <Head
        heading="Transformative Retreats"
        subheading="Disconnect from the chaos. Reclaim your energy, clarity, and inner peace."
        content={[
          <>
            Our wellness retreats are designed to help you recharge, refocus, and rediscover joy—whether you need a break from stress, clarity on your next steps, or a deep inner transformation.
          </>,
        ]}
        subcontent={[
          <>
            <strong>Choose the best retreat for you :</strong>
          </>,
        ]}
      />
      
      {/* Retreats Section */}
      <div className="mt-8 space-y-8">
        {retreats.map((retreat, index) => (
          <Card key={index} {...retreat} />
        ))}
      </div>
    </div>
  );
};

export default Retreats;
